document.addEventListener('DOMContentLoaded', function () {

  // The two h2s we want to KEEP (matched by text content)
  var keepHeadings = [
    'mediterranean pool tiles for luxury pools',
    'specified across warm-climate luxury markets'
  ];

  // The h2s we want to HIDE (matched by text content)
  var hideHeadings = [
    'designed for pools',
    'authentic mediterranean craftsmanship',
    'frequently asked questions'
  ];

  // ── Only touch h2s that match our known hide list ──
  // This prevents accidentally hiding carousel/slideshow titles
  var hiddenEls = [];

  document.querySelectorAll('h2').forEach(function (h2) {
    var text = h2.textContent.trim().toLowerCase();
    var shouldHide = hideHeadings.some(function (k) { return text.includes(k); });
    if (!shouldHide) return;

    hiddenEls.push(h2);
    h2.style.display = 'none';

    // Also hide the paragraph(s) and h3s that follow
    var next = h2.nextElementSibling;
    while (next) {
      var tag = next.tagName.toLowerCase();
      if (tag === 'p' || tag === 'h3' || tag === 'ul' || tag === 'ol') {
        hiddenEls.push(next);
        next.style.display = 'none';
        next = next.nextElementSibling;
      } else {
        break;
      }
    }
  });

  // Hide the footer link paragraph (tile category links)
  document.querySelectorAll('p').forEach(function (p) {
    var links = p.querySelectorAll('a');
    var text = p.textContent.toLowerCase();
    if (
      links.length >= 3 &&
      (text.includes('spanish colonial') || text.includes('moroccan zellige') || text.includes('moorish mosaic'))
    ) {
      hiddenEls.push(p);
      p.style.display = 'none';
    }
  });

  // ── "Read more" button after the last keeper paragraph ──
  var lastKeeperP = null;
  document.querySelectorAll('h2').forEach(function (h2) {
    var text = h2.textContent.trim().toLowerCase();
    if (keepHeadings.some(function (k) { return text.includes(k); })) {
      var next = h2.nextElementSibling;
      if (next && next.tagName.toLowerCase() === 'p') {
        lastKeeperP = next;
      }
    }
  });

  if (lastKeeperP) {
    var btn = document.createElement('button');
    btn.textContent = 'Read more';
    btn.style.cssText = [
      'background:none',
      'border:none',
      'padding:0',
      'margin-top:12px',
      'font-size:13px',
      'letter-spacing:0.08em',
      'text-transform:uppercase',
      'color:inherit',
      'opacity:0.6',
      'cursor:pointer',
      'text-decoration:underline',
      'display:block'
    ].join(';');

    var expanded = false;
    btn.addEventListener('click', function () {
      expanded = !expanded;
      hiddenEls.forEach(function (el) {
        el.style.display = expanded ? '' : 'none';
      });
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });

    lastKeeperP.insertAdjacentElement('afterend', btn);
  }

});
